<template lang="pug">

  .component-toc-controller
    .row
      .columns
        router-view
</template>
<script type="text/babel">

  export default {
    name: "TocController",
    data() {
    },
    created() {
    },
    methods: {},
    computed: {},
    props: ['item'],

  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// Toc.vue?30b525c0